import { useCallback, useState } from 'react';

export const useClientTypePricingRuleCard = () => {
  const [addModalState, setAddModalState] = useState<boolean>(false);
  const onAddModalStateChange = useCallback(() => {
    setAddModalState((prevState) => !prevState);
  }, []);

  return {
    addModalState,
    onAddModalStateChange,
  };
};
